import React from 'react';
import PropTypes from 'prop-types';
import './UnsavedChangesDialog.css';

const UnsavedChangesDialog = ({ isOpen, onDiscard, onSave, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="unsaved-dialog-overlay">
      <button type="button" className="unsaved-dialog-overlay-btn" onClick={onCancel} aria-label="Dialog schließen" />
      <dialog className="unsaved-dialog" open aria-label="Ungespeicherte Änderungen">
        <div className="unsaved-dialog-header">
          <span className="unsaved-icon"><i className="bi bi-exclamation-triangle-fill"></i></span>
          <h5>Ungespeicherte Änderungen</h5>
        </div>
        <div className="unsaved-dialog-body">
          Es gibt ungespeicherte Änderungen am aktuellen Diagramm.<br />
          Was möchten Sie tun?
        </div>
        <div className="unsaved-dialog-footer">
          <button className="btn unsaved-btn-discard" onClick={onDiscard}>
            <i className="bi bi-trash"></i> Verwerfen
          </button>
          <button className="btn unsaved-btn-save" onClick={onSave}>
            <i className="bi bi-save"></i> Speichern
          </button>
          <button className="btn unsaved-btn-cancel" onClick={onCancel}>
            Abbrechen
          </button>
        </div>
      </dialog>
    </div>
  );
};

UnsavedChangesDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onDiscard: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default UnsavedChangesDialog;
